module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 middleTable",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "search": _vm.search,
      "items": _vm.quoteItems,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "middle"
        }, [_c('th', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("QUANTITY")]), _vm._v(" "), _c('th', [_vm._v("UOM")]), _vm._v(" "), _c('th', {
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("UNIT COSTS")]), _vm._v(" "), _c('th', [_vm._v("GROSS")]), _vm._v(" "), _c('th', [_vm._v("DISCOUNT")]), _vm._v(" "), _c('th', [_vm._v("NETT")])]), _vm._v(" "), _c('tr', {
          staticClass: "smaller middle"
        }, [_c('th', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Requested")]), _vm._v(" "), _c('th', [_vm._v("Actual")]), _vm._v(" "), _c('th', [_vm._v("Uom")]), _vm._v(" "), _c('th', [_vm._v("Gross")]), _vm._v(" "), _c('th', [_vm._v("Discount")]), _vm._v(" "), _c('th', [_vm._v("Nett")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-switch', {
          on: {
            "change": function($event) {
              return _vm.fncAddSelectedTotal(props.item.price, props.item.winning)
            }
          },
          model: {
            value: (props.item.winning),
            callback: function($$v) {
              _vm.$set(props.item, "winning", $$v)
            },
            expression: "props.item.winning"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(_vm.fncFilterName(props.item.name)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.quantity))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.quantity_calc))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFilterName(props.item.uom)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.price)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.discount)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFormatNett(props.item.price, props.item.discount)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFormatTotal(props.item.price, props.item.quantity_calc)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFormatTotal(props.item.discount, props.item.quantity)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFormatTotalNett(props.item.price, props.item.quantity_calc, props.item.discount, props.index)))])]
      }
    }])
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 hideTable",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "items": _vm.emptyItems,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "smaller middle",
          staticStyle: {
            "border": "none"
          }
        }, [_c('th', {
          staticStyle: {
            "font-size": "12px",
            "text-align": "right !important",
            "padding": "2% !important"
          },
          attrs: {
            "colspan": "10"
          }
        }, [_c('strong', [_vm._v("NETT TOTAL")]), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.fncFilterPrice(_vm.totalNett)))]), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("VAT @ 15%")]), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.fncCalculateVat()))]), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("TOTAL")]), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.fncFinalTotal()))]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("SELECTED TOTAL")]), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.fncSelectedTotal()))])])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": _vm.totalSelected == 0
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateProjectQuote.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)
},staticRenderFns: []}